import { API_URL } from '../constants';

export const adminLogin = async (email: string, password: string) => {
    try {
     

        const response = await fetch(`${API_URL}/auth/login?email_address=${email}&password=${password}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
            },
        });

        const data = await response.json();

        if (!response.ok || data.error) {
            throw new Error(data.message || 'Giriş başarısız');
        }

        return data;
    } catch (error) {
        console.error('Giriş hatası:', error);
        throw error;
    }
};
